import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { HSTSToast } from "../../utils/hstsToast";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";
import { ToastContainer } from "react-toastify";
import {
  getStudentByEmail,
  updateStudent,
  uploadProfileImage,
} from "../../services/StudentService";
import { useUser } from "../../utils/userProvider";

const StudentAccount = () => {
  const { user } = useUser();
  const navigator = useNavigate();

  const id = user?.email;

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [ageGroup, setAgeGroup] = useState("");
  const [studentId, setStudentId] = useState("");
  const [profileImage, setProfileImage] = useState("/assets/img/c.png");
  // const API_BASE_URL = "http://localhost:8285";
  const API_BASE_URL = "https://hetras.suza.ac.tz/hetras";
  const IMAGE_ENDPOINT_ROOT = "/students"; 

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  const [errors, setErrors] = useState({
    fullName: "",
    phoneNumber: "",
    gender: "",
    emailAddress: "",
    ageGroup: "",
  });

  const [touched, setTouched] = useState({
    fullName: false,
    phoneNumber: false,
    gender: false,
    emailAddress: false,
    ageGroup: false,
  });

  const isValidPhoneNumber = (number) => {
    const localPattern = /^(06|07)\d{8}$/;
    const intlPattern = /^\+255\s[67]\d{2}\s\d{3}\s\d{3}$/;
    return localPattern.test(number) || intlPattern.test(number);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const formValidation = () => {
    let valid = true;
    const copy = { ...errors };

    if (!fullName.trim()) {
      copy.fullName = "Full name is required.";
      valid = false;
    } else copy.fullName = "";

    if (!phoneNumber.trim()) {
      copy.phoneNumber = "Phone number is required.";
      valid = false;
    } else if (!isValidPhoneNumber(phoneNumber.trim())) {
      copy.phoneNumber =
        "Invalid phone format. Use 0769xxxxxx or +255 769 xxx xxx.";
      valid = false;
    } else copy.phoneNumber = "";

    if (!gender.trim()) {
      copy.gender = "Gender is required.";
      valid = false;
    } else copy.gender = "";

    if (!ageGroup.trim()) {
      copy.ageGroup = "Age group is required.";
      valid = false;
    } else copy.ageGroup = "";

    if (!emailAddress.trim()) {
      copy.emailAddress = "Email is required.";
      valid = false;
    } else if (!validateEmail(emailAddress)) {
      copy.emailAddress = "Invalid email address.";
      valid = false;
    } else copy.emailAddress = "";

    setErrors(copy);
    return valid;
  };

  const saveOrUpdateStudent = async (e) => {
    e.preventDefault();
    setTouched({
      fullName: true,
      phoneNumber: true,
      gender: true,
      emailAddress: true,
      ageGroup: true,
    });

    if (formValidation()) {
      const studentStatus = "enable";
      const student = {
        fullName,
        phoneNumber,
        gender,
        ageGroup,
        emailAddress,
        studentStatus,
      };

      if (studentId) {
        updateStudent(studentId, student)
          .then(() => {
            HSTSToast("success", "Profile updated successfully");
            navigator("/student/profile");
          })
          .catch((err) => console.error(err));
      }
    }
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    formValidation();
  };

  const getInputClass = (fieldName, value) => {
    if (!touched[fieldName]) return "form-control";
    if (errors[fieldName]) return "form-control is-invalid";
    if (value.trim()) return "form-control is-valid";
    return "form-control";
  };

  useEffect(() => {
    if (id) {
      getStudentByEmail(id)
        .then((response) => {
          const s = response.data;
          setFullName(s.fullName);
          setPhoneNumber(s.phoneNumber);
          setGender(s.gender);
          setAgeGroup(s.ageGroup);
          setEmailAddress(s.emailAddress);
          setStudentId(s.studentId);

          if (s.profileImage && s.studentId) {
            const timestamp = new Date().getTime();

            const baseImageUrl = `${API_BASE_URL}${IMAGE_ENDPOINT_ROOT}/${s.studentId}/profileImage`;

            setProfileImage(`${baseImageUrl}?t=${timestamp}`);
          } else {
            setProfileImage("/assets/img/c.png");
          }
        })
        .catch((error) => console.error("Error fetching student:", error));
    }
  }, [id]);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(URL.createObjectURL(file));

      try {
        const response = await uploadProfileImage(studentId, file);

        if (response.status === 200) {
          const timestamp = new Date().getTime();

          const newImageUrl = `${API_BASE_URL}${IMAGE_ENDPOINT_ROOT}/${studentId}/profileImage?t=${timestamp}`;

          setProfileImage(newImageUrl);
          HSTSToast("success", "Profile image uploaded successfully");
        } else {
          HSTSToast(
            "error",
            "Failed to upload image. Status: " + response.status
          );
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        HSTSToast("error", "Error uploading image");
      }
    }
  };

  return (
    <>
      {/* <div className="wrapper"> */}
      <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
        <SideBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeMenu={activeMenu}
          toggleMenu={toggleMenu}
          windowWidth={windowWidth}
        />
        <div className="main-panel">
          <TopHeader
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            windowWidth={windowWidth}
          />
          <div className="container mt-0">
            <div className="page-inner">
              <div className="page-header bg-white zis-shadow rounded-2 mt-2">
                <ul className="breadcrumbs my-md-3 mb-3 ms-0">
                  <li className="nav-home">
                    <Link to="/student" className="ps-3 ps-md-0">
                      <span className="fa fa-home"></span>
                    </Link>
                  </li>
                  <li className="separator">
                    <i className="fas fa-chevron-right text-secondary"></i>
                  </li>
                  <li className="nav-item text-black fw-semibold">
                    <Link to="#">My account</Link>
                  </li>
                </ul>
              </div>

              <div className="row mt-5 align-items-center h-100">
                <form
                  className="col-lg-4 col-12 mx-auto"
                  onSubmit={saveOrUpdateStudent}
                >
                  <div className="card zis-shadow rounded-3">
                    <div className="card-header">
                      <div className="d-flex justify-content-center mt-4">
                        <div
                          className="profile-img-container position-relative zis-ponter"
                          onClick={() =>
                            document.getElementById("profileImageInput").click()
                          }
                        >
                          <img
                            src={profileImage || "/assets/img/c.png"}
                            alt="Profile"
                            className="rounded-circle img-fluid profile-picture"
                          />
                          <div className="golden-ring"></div>
                          <div className="floral-deco position-absolute"></div>
                          <div className="add-user-icon position-absolute rounded-circle bg-secondary text-white d-flex justify-content-center align-items-center">
                            <i className="bi bi-person-plus-fill"></i>
                          </div>
                        </div>

                        <input
                          id="profileImageInput"
                          type="file"
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                        />
                      </div>

                      <h4 className="mt-3 mb-0 fw-bold text-center">
                        {fullName}
                      </h4>
                      <p className="text-muted small text-center  fw-bold">
                        Student
                      </p>
                    </div>

                    <div className="card-body">
                      <div className="form-group mb-2">
                        <label className="text-black">Full Name</label>
                        <input
                          type="text"
                          className={getInputClass("fullName", fullName)}
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                          onBlur={() => handleBlur("fullName")}
                          placeholder="Enter full name"
                        />
                        {errors.fullName && (
                          <div className="invalid-feedback">
                            {errors.fullName}
                          </div>
                        )}
                      </div>

                      <div className="form-group mb-2">
                        <label className="text-black">Phone Number</label>
                        <input
                          type="tel"
                          className={getInputClass("phoneNumber", phoneNumber)}
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          onBlur={() => handleBlur("phoneNumber")}
                          placeholder="Please enter phone number"
                        />
                        {errors.phoneNumber && (
                          <div className="invalid-feedback">
                            {errors.phoneNumber}
                          </div>
                        )}
                      </div>

                      <div className="form-group mb-2">
                        <label className="text-black">Age group</label>
                        <select
                          className={
                            touched.ageGroup
                              ? errors.ageGroup
                                ? "form-select is-invalid"
                                : "form-select is-valid"
                              : "form-select"
                          }
                          value={ageGroup}
                          onChange={(e) => setAgeGroup(e.target.value)}
                          onBlur={() => handleBlur("ageGroup")}
                        >
                          <option value="">Select ageGroup</option>
                          <option value="18 – 27">18 – 27</option>
                          <option value="28 – 37">28 – 37</option>
                          <option value="38 – 47">38 – 47</option>
                          <option value="48 – Above">48 – Above</option>
                        </select>
                        {errors.ageGroup && (
                          <div className="invalid-feedback">
                            {errors.ageGroup}
                          </div>
                        )}
                      </div>

                      <div className="form-group mb-2">
                        <label className="text-black">Gender</label>
                        <select
                          className={
                            touched.gender
                              ? errors.gender
                                ? "form-select is-invalid"
                                : "form-select is-valid"
                              : "form-select"
                          }
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                          onBlur={() => handleBlur("gender")}
                        >
                          <option value="">Select Gender</option>
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                        </select>
                        {errors.gender && (
                          <div className="invalid-feedback">
                            {errors.gender}
                          </div>
                        )}
                      </div>

                      <button
                        type="submit"
                        className="btn btn-black w-100 rounded-3 mb-4"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default StudentAccount;
